import Vue from 'vue'
import Router from 'vue-router'

import Login from './views/Auth/Login'
import Master from './components/Layouts/Master';

import Dashboard from './components/Dashboard';
import Configuration from './components/Configuration';

import Patients from '@/components/Catalogs/Patients/Index';
import Recommendations from '@/components/Catalogs/Recommendations/Index';

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      component: Login
    },
    {
      path: '/',
      name: 'Master',
      component: Master,
      beforeEnter(to, from, next) {
        if (!window.localStorage.token) {
          next('/login')
        }
        next()
      },
      redirect: '/dashboard',
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/configuracion/general',
          name: 'Configuration',
          component: Configuration
        },
        {
          path: '/configuracion/dias-inhabiles',
          component: () => import('@/components/configuration/DisabledDates.vue')
        },
        {
          path: '/catalogos/pacientes',
          name: 'Patients',
          component: Patients
        },
        {
          path: '/catalogos/recomendaciones',
          name: 'Recommendations',
          component: Recommendations
        }
      ]
    },
  ]
})
